<template>
  <b-dialog
  :mask="false"
  :mshow="show">
    <div class="toast-wrap">
      <div :class="myClass">
      <!-- <div class="beast__toast" :class='{ beast__alert : alert || confirm }'> -->
        <div class="content" >
          <div class="content-item">
            <!-- <div class="title" v-if=""> -->
            <div class="title">
              {{ title }}
            </div>
            <div :class="{ lighter : title }">
              {{ content }}
            </div>
          </div>
        </div>
        <div class="alert" v-if="alert" v-on:click="close">
          {{ primary }}
        </div>
        <div class="confirm" v-if="confirm">
          <div class="cancel" @click="cancel">{{ secondary }}</div>
          <div class="ensure" @click="ensure">{{ primary }}</div>
        </div>
      </div>
    </div>
  </b-dialog>
</template>

<script>

import BDialog from '@/components/dialog'
let _confirm_state
let _data = {
    show: false,
    time: 2000,
    autoClose: false,
    toast: false,
    alert: false,
    confirm: false,
    primary : "确定",
    secondary : "取消",
    title: '',
    content: '',
    myClass: 'beast__toast'
  }
export default {
  components: {
    BDialog
  },
  data () {
    return JSON.parse(JSON.stringify(_data))
  },
  watch: {
    content (val){
      if(val){
        this.show = true
      }
    },
    toast (val){
      if(val){
        this.myClass = 'beast__toast'
      }
    },
    alert (val){
      if(val){
        this.myClass = 'beast__alert'
      }
    },
    confirm (val){
      if(val){
        this.myClass = 'beast__confirm'
      }
    },
    show (val){
      this.autoClose && clearTimeout(this.timeout)
      if(val){
        this.autoClose && (this.timeout = setTimeout(() => {
          this.show = false
        },this.time))
      }else{
        this.toast && this.$emit('toast-hide')
        this.alert && this.$emit('alert-hide')
        if(this.confirm){
           _confirm_state
              ?this.$emit('confirm-ensure')
              :this.$emit('confirm-cancel')
        }

        for(let _key in _data){
          this[_key] = _data[_key]
        }
      }
    }
  },
  methods: {
    close: function(event){
      this.show = false
    },
    cancel: function(event){
      _confirm_state = false
      this.show = false
    },
    ensure: function(event){
      _confirm_state = true
      this.show = false
    }
  }
}
</script>

<style lang="stylus">
  @import './index'
</style>



// WEBPACK FOOTER //
// index.vue?389a03a4